import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { BusinessAreaLookup } from './business-area-lookup.type';

const OrganisationLookup = t.type(
  {
    businessAreas: nullable(t.array(BusinessAreaLookup)),
  },
  'OrganisationLookup',
);

type OrganisationLookup = t.TypeOf<typeof OrganisationLookup>;
export { OrganisationLookup };
